import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { faqService, FAQPage } from './faq-service'
import { toast } from 'sonner'

export function useFAQ() {
    const queryClient = useQueryClient()

    const { data: faq, isLoading } = useQuery({
        queryKey: ['faq'],
        queryFn: faqService.getFAQPage,
    })

    const updateFAQMutation = useMutation({
        mutationFn: ({ data, translate }: { data: Partial<FAQPage>, translate?: boolean }) =>
            faqService.updateFAQPage(data, translate),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['faq'] })
            toast.success('SSS içeriği başarıyla güncellendi.')
        },
        onError: (err: any) => {
            toast.error(err.response?.data?.message || 'Güncelleme sırasında bir hata oluştu.')
        },
    })

    const updateFAQ = async ({ data, translate }: { data: Partial<FAQPage>, translate?: boolean }) => {
        return await updateFAQMutation.mutateAsync({ data, translate });
    };

    return {
        faq,
        isLoading,
        updateFAQ,
        isUpdating: updateFAQMutation.isPending
    };
}
